module.exports = __webpack_public_path__ + "img/25.f4cf4922.jpg";